__turbopack_context__.v({
  "accessStatus": "master-module__sGqrvG__accessStatus",
  "avatar": "master-module__sGqrvG__avatar",
  "back": "master-module__sGqrvG__back",
  "badge": "master-module__sGqrvG__badge",
  "badgeNeutral": "master-module__sGqrvG__badgeNeutral",
  "badgeOff": "master-module__sGqrvG__badgeOff",
  "brand": "master-module__sGqrvG__brand",
  "companyForm": "master-module__sGqrvG__companyForm",
  "companyName": "master-module__sGqrvG__companyName",
  "content": "master-module__sGqrvG__content",
  "domain": "master-module__sGqrvG__domain",
  "empty": "master-module__sGqrvG__empty",
  "error": "master-module__sGqrvG__error",
  "eyebrow": "master-module__sGqrvG__eyebrow",
  "financeNotes": "master-module__sGqrvG__financeNotes",
  "footer": "master-module__sGqrvG__footer",
  "heading": "master-module__sGqrvG__heading",
  "hidden": "master-module__sGqrvG__hidden",
  "integration": "master-module__sGqrvG__integration",
  "lockIcon": "master-module__sGqrvG__lockIcon",
  "loginCard": "master-module__sGqrvG__loginCard",
  "loginNote": "master-module__sGqrvG__loginNote",
  "loginPage": "master-module__sGqrvG__loginPage",
  "loginStory": "master-module__sGqrvG__loginStory",
  "masterPill": "master-module__sGqrvG__masterPill",
  "metric": "master-module__sGqrvG__metric",
  "metrics": "master-module__sGqrvG__metrics",
  "navActive": "master-module__sGqrvG__navActive",
  "navItem": "master-module__sGqrvG__navItem",
  "navLabel": "master-module__sGqrvG__navLabel",
  "networkBranches": "master-module__sGqrvG__networkBranches",
  "networkCard": "master-module__sGqrvG__networkCard",
  "networkVisual": "master-module__sGqrvG__networkVisual",
  "notice": "master-module__sGqrvG__notice",
  "overviewGrid": "master-module__sGqrvG__overviewGrid",
  "panel": "master-module__sGqrvG__panel",
  "panelFoot": "master-module__sGqrvG__panelFoot",
  "panelHeading": "master-module__sGqrvG__panelHeading",
  "primary": "master-module__sGqrvG__primary",
  "roleGrid": "master-module__sGqrvG__roleGrid",
  "root": "master-module__sGqrvG__root",
  "route": "master-module__sGqrvG__route",
  "search": "master-module__sGqrvG__search",
  "secondary": "master-module__sGqrvG__secondary",
  "settingsRows": "master-module__sGqrvG__settingsRows",
  "shortcuts": "master-module__sGqrvG__shortcuts",
  "sideBottom": "master-module__sGqrvG__sideBottom",
  "sideDivider": "master-module__sGqrvG__sideDivider",
  "sideTag": "master-module__sGqrvG__sideTag",
  "sidebar": "master-module__sGqrvG__sidebar",
  "statusList": "master-module__sGqrvG__statusList",
  "storyLines": "master-module__sGqrvG__storyLines",
  "table": "master-module__sGqrvG__table",
  "tableWrap": "master-module__sGqrvG__tableWrap",
  "textButton": "master-module__sGqrvG__textButton",
  "toolbar": "master-module__sGqrvG__toolbar",
  "topbar": "master-module__sGqrvG__topbar",
  "workspace": "master-module__sGqrvG__workspace",
});
